import { DotsCheckbox } from "dots-ui/dotsCheckbox";
import { FormikProps } from "formik";
import { useContext } from "react";
import {
  ItemViewModel,
  LicenseCreationsFilter,
} from "../../../../../../../../generated/data-contracts";
import { FormikUtils } from "../../../../../../../../utils";
import { isMobileView } from "../../../../../../../shared/appStates/appStates";
import {
  AvisErrorMessage,
  FilterActions,
} from "../../../../../../../shared/components/form";
import {
  AvisDropdown,
  AvisInputText,
  AvisInputTextWithFilterType,
} from "../../../../../../../shared/components/inputs";
import { AvisContext } from "../../../../../../../shared/context/AvisContext";

interface ILicenseCreationsFilterFormProps {
  bag: FormikProps<LicenseCreationsFilter>;
  creationClasses: ItemViewModel[];
  loading: boolean;
  filtered: boolean;
}

export function LicenseCreationsFilterForm(
  props: Readonly<ILicenseCreationsFilterFormProps>,
) {
  const { bag, loading, creationClasses, filtered } = props;
  const { res } = useContext(AvisContext);

  const classnameRows = isMobileView.value ? "" : "row";
  const classnameFields = isMobileView.value ? "col-10" : "col-5";

  //Validation error set to pageSize to prevent seperate field highlight
  const errorRequired1Of3Fields = bag.errors.pageSize;

  return (
    <>
      <div className={classnameRows}>
        <AvisDropdown<ItemViewModel, LicenseCreationsFilter>
          label={res("label_CreationClassName")}
          className={classnameFields}
          options={creationClasses}
          bag={bag}
          bagField="creationClassId"
          disabled={loading}
          optionValue="id"
          optionLabel="name"
        />
        <AvisInputText<LicenseCreationsFilter>
          className={classnameFields}
          label={res("label_Author")}
          bag={bag}
          bagField="rightsHolderName"
          disabled={loading}
          maxLength={200}
          onKeyDown={(e) => FormikUtils.handleEnterKeyPress(e, bag.submitForm)}
        />
      </div>
      <div className={classnameRows}>
        <AvisInputTextWithFilterType<LicenseCreationsFilter>
          className={classnameFields}
          label={res("label_Title")}
          bag={bag}
          bagField="creationName"
          bagFieldFilterType="creationNameFilterType"
          disabled={loading}
          maxLength={200}
          onKeyDown={(e) => FormikUtils.handleEnterKeyPress(e, bag.submitForm)}
        />
        <AvisInputText<LicenseCreationsFilter>
          className={classnameFields}
          label={res("label_Performer")}
          bag={bag}
          bagField="creationBand"
          disabled={loading}
          minLength={2}
          maxLength={200}
          onKeyDown={(e) => FormikUtils.handleEnterKeyPress(e, bag.submitForm)}
        />
      </div>
      <div className="row">
        <div className="col-12">
          <DotsCheckbox<LicenseCreationsFilter>
            checkboxLabel={res("label_SearchAllCreationNames")}
            bag={bag}
            bagField="searchAllNames"
            disabled={loading}
          />
        </div>
      </div>
      {errorRequired1Of3Fields && (
        <AvisErrorMessage
          value={errorRequired1Of3Fields}
          className="dots-input-error-message"
        />
      )}
      <FilterActions
        bag={bag}
        loading={loading}
        res={res}
        filtered={filtered}
      />
    </>
  );
}
